<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="msgSemResultado">
        Não foram encontrados conglomerados com os filtros informados.
    </div>

    <div *ngIf="conglomerados && conglomerados.length">
        <div class="d-flex justify-content-end">
            <button [disabled]="conglomerados.length == 0" class="btn btn-secondary m-0" type="button" (click)="btnExportarListaConglomerado()"
            placement="top" ngbTooltip="Exporta todos os conglomerados listados">
            <i class="fa fa-file"></i> Exportar conglomerado</button>
        </div>
        <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
        <bn-paginacao
            [total]="atributosPaginacao.count"
            [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
            [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
            <div class="table-responsive">
                <table class="table table-hover cursor-pointer">
                    <thead>
                        <tr class="text-nowrap">
                            <th id="col-agente" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'agenteFinanceiro.nome'"
                                    [nomeAtributoExibicao]="'Agente Financeiro'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-data-inicio" scope="col" class="text-center">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'percentual'"
                                    [nomeAtributoExibicao]="'Percentual %'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-data-fim" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'dataInicial'"
                                    [nomeAtributoExibicao]="'Data Início'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-motivo" scope="col">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'dataFinal'"
                                    [nomeAtributoExibicao]="'Data Fim'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-motivo" scope="col" class="text-center">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'codigo'"
                                    [nomeAtributoExibicao]="'Código Conglomerado'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-motivo" scope="col" class="text-center">
                                <bn-ordenacao
                                    [ordenacao]="atributosOrdenacao"
                                    [atributo]="'situacao'"
                                    [nomeAtributoExibicao]="'Situação'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                        </tr>
                    </thead>

                    <tbody>
                        <ng-container *ngFor="let conglomerado of conglomerados; let i = index">
                            <tr *ngIf="podeCadastrarConglomerado; else naoPodeCadastrarEditar"
                                (mouseenter)="hover(i)"
                                (mouseleave)="hoverClean()"
                                [routerLink]="['/habilitacao/conglomerado/', conglomerado.idConglomerado]">
                                <td>{{ conglomerado.agenteFinanceiro.sigla.toUpperCase() }}</td>
                                <td class="text-center">{{ conglomerado.percentual | percent: '2.2-4' }}</td>
                                <td>{{ conglomerado.dataInicial | date: 'dd/MM/yyyy' }}</td>
                                <td>{{ conglomerado.dataFinal | date: 'dd/MM/yyyy' }}</td>
                                <td class="text-center">{{ conglomerado.codigo | numeroConglomerado }}</td>
                                <td class="text-center">{{ conglomerado.situacao }}
                                    <i *ngIf="rowHovered === i" class="fa fa-pen cursor-pointer text-primary ms-4" placement="left-top" ngbTooltip="Editar conglomerado"></i>
                                </td>
                            </tr>
                            <ng-template #naoPodeCadastrarEditar>
                                <tr>
                                    <td>{{ conglomerado.agenteFinanceiro.sigla.toUpperCase() }}</td>
                                    <td class="text-center">{{ conglomerado.percentual | percent: '2.2-4' }}</td>
                                    <td>{{ conglomerado.dataInicial | date: 'dd/MM/yyyy' }}</td>
                                    <td>{{ conglomerado.dataFinal | date: 'dd/MM/yyyy' }}</td>
                                    <td class="text-center">{{ conglomerado.codigo | numeroConglomerado }}</td>
                                    <td class="text-center">{{ conglomerado.situacao }}</td>
                                </tr>
                            </ng-template>
                        </ng-container>
                    </tbody>

                </table>
            </div>
        </bn-paginacao>
    </div>
</div>
